import { useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { useCart } from '../context/CartContext';
import { formatVND, effectivePrice, pickLang, emojiFor } from '../lib/format';

export default function ProductCard({ product }) {
  const { lang, t } = useLang();
  const { add } = useCart();
  const [added, setAdded] = useState(false);

  const price = effectivePrice(product);
  const onSale = Number(product.sale_price) && Number(product.sale_price) < Number(product.price);

  const handleAdd = () => {
    add({
      kind: 'product',
      id: product.id,
      name: product.name,
      name_en: product.name_en,
      price,
      category: product.category,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1200);
  };

  return (
    <div className="pcard">
      <div className="pcard-img">
        {product.image_url ? <img src={product.image_url} alt={pickLang(product, 'name', lang)} /> : emojiFor(product.category)}
      </div>
      <div className="pcard-body">
        <div className="row" style={{ gap: 4 }}>
          {product.is_hot_seasonal && <span className="badge badge-hot">{t('b.hot')}</span>}
          {product.is_best_seller && <span className="badge badge-best">{t('b.best')}</span>}
          {product.is_limited && <span className="badge badge-limited">{t('b.limited')}</span>}
          {onSale && <span className="badge badge-sale">{t('b.sale')}</span>}
          {product.is_favorite && <span className="badge badge-fav">{t('b.fav')}</span>}
        </div>
        <div className="pcard-name">{pickLang(product, 'name', lang)}</div>
        <div className="pcard-desc">{pickLang(product, 'description', lang)}</div>
        <div>
          <span className="price">{formatVND(price)}</span>
          {onSale && <span className="price-old">{formatVND(product.price)}</span>}
        </div>
        <button className="btn btn-primary btn-sm" onClick={handleAdd}>
          {added ? t('p.added') : t('p.addToCart')}
        </button>
      </div>
    </div>
  );
}
